import React, { createContext, useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { AppStateContextProps } from './types/app-state-context-props';
import { AppError } from './types/app-error';
import { CriticalAppError } from './types/critical-app-error';

export const AppStateContext = createContext<AppStateContextProps>(null!);

export function AppStateProvider(props: React.PropsWithChildren<unknown>) {
    const history = useHistory();
    const [appReady, setAppReady] = useState<boolean>(false);

    const context = {
        appReady,
        setAppReady,
        setError: (error: AppError) => {
            console.error("App Error: ",error);
        },
        setCriticalError: (error: CriticalAppError) => {
            console.error("Critical App Error: ", error);
            history.push('/critical-error');
        },
    } as AppStateContextProps;

    return <AppStateContext.Provider value={{ ...context }}>{props.children}</AppStateContext.Provider>;
}

export function useAppState() {
    const context = useContext(AppStateContext);

    if (!context) {
        throw new Error('useAppState must be used within the AppStateProvider');
    }

    return context;
}
